import React from "react";
import ChatDemon from "../../assets/cards img/chatdemon.png";
const OurStory = () => {
    return (
        <section className="relative  px-6 md:px-[10%] overflow-hidden">
            <div className="relative z-10 max-w-10xl mx-auto">
                <div className="text-center mb-12">
                    <span className="font-medium text-md text-black md:pt-10 dark:text-white">
                        Our Mission
                    </span>
                    <h2 className="font-bold text-3xl text-black pt-2 pb-3 md:text-5xl md:pb-10 dark:text-white">
                        Connecting students with seniors for guidance
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    
                    <div className="backdrop-blur-xl p-10 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 bg-white flex flex-col items-center text-center dark:bg-[#0651c3]">
                        <img className="h-[7rem]" src={ChatDemon} alt="Community" />
                        <h3 className="font-bold text-black text-3xl dark:text-white ">
							Democratizing Education
						</h3>
                       <p className="text-blueGrey text-justify font-medium text-md dark:text-white md:text-xl pt-4">
						We believe quality placement preparation shouldn't come with a premium price tag. Our goal is to provide top-tier resources completely for free, bridging the gap between talent and opportunity regardless of background.
						</p>
                    </div>

                    <div className="backdrop-blur-xl p-10 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 bg-white flex flex-col items-center text-center dark:bg-[#0651c3]">
                        <img className="h-[5rem] pt-2" src="https://www.iconpacks.net/icons/1/free-user-group-icon-296-thumb.png" alt="Community" />
                        <h3 className="font-bold text-black text-3xl dark:text-white pt-4">
							Community First
						</h3>
                       <p className="text-blueGrey text-justify font-medium text-md dark:text-white md:text-xl pt-6">
						Started in Jan 2023, what began as a small Discord server has grown into a thriving ecosystem. From Daily Contest Discussions (DCDs) to expert mentorship, we grow together as one.
						</p>
                    </div>

                </div>

                <div className="mt-12  p-8 md:p-12 text-center text-black dark:text-white relative z-10 bg-gradient-to-tr from-blue-100 to-purple-100 dark:from-white/10 dark:to-white/5  rounded-[3rem] backdrop-blur-sm border border-white/50 dark:border-white/10">
                    <h3 className="text-2xl md:text-3xl font-bold mb-4">
                        Join Thousands of Learners
                    </h3>
                    <p className="text-blue-100 text-lg max-w-2xl mx-auto mb-8">
                        Whether you are targeting FAANG or high-growth startups, our structured roadmaps and peer community are here to guide you every step of the way.
                    </p>
                    <a 
                        href="https://chat.whatsapp.com/IANhN5eCMfO6773H96KFN1"
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-2 bg-black dark:bg-white text-white dark:text-black hover:bg-blue dark:hover:bg-blue hover:text-white dark:hover:text-white px-8 py-3 rounded-full font-bold text-lg hover:bg-blue transition-colors shadow-lg"
                    >
                        Join Our Community
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                    </a>
                </div>

            </div>
        </section>
    );
};

export default OurStory;